// 登录状态
export const LOGIN_STATUS = 'LOGIN_STATUS';

export const UPDATEHEADER = 'UPDATEHEADER';
// 更新用户
export const UPDATEUER = 'UPDATEUER';
// 移除用户
export const REMOVEUSER = 'REMOVEUSER';

// 更新实名信息
export const UPDATEREAL = 'UPDATEREAL';
// 移除实名信息
export const REMOVEREAL = 'REMOVEREAL';

// 更新地址信息
export const UPDATEADDRESS = 'UPDATEADDRESS';
// 移除地址信息
export const REMOVEADDRESS = 'REMOVEADDRESS';

// 更新银行卡信息
export const UPDATECARD = 'UPDATECARD';
// 移除银行卡信息
export const REMOVECARD = 'REMOVECARD';

// 更新添加银行卡信息
export const UPDATEADDCARD = 'UPDATEADDCARD';
// 移除添加银行卡信息
export const REMOVEADDCARD = 'REMOVEADDCARD';

// 更新分公司信息
export const UPDATESHARE = 'UPDATESHARE';
// 移除分公司信息
export const REMOVESHARE = 'REMOVESHARE';



// WEBPACK FOOTER //
// ./src/store/types.js